import Dexie, { Table } from 'dexie';
import type { KWAART, KWAARB, KZUWA, KWAPRS, KWAMAN, KWAMAS, KWASTM, KWAPRU, KWAMGZ, KWAMZN } from './wartungDB';
import { HistorieNode } from 'src/app/content/_components/detailview/historie-tree/historie-tree.component';
import { Table as DGTable } from 'src/app/models/ui/table';
import { KTOLR, NMESS, SZAEEH, SZAEHN, SZAEHW } from './zaehlerDB';
import { ReplikatMeta } from './rep-setup.service';
import { OSTAMM, SOTYP } from './anlagenDB';
import {
  BASE_ITEM,
  BASE_ITEM_OTYPID,
  KSPEZW,
  SBAGP,
  SBAUW,
  SBFEK,
  SGATT,
  SMANG,
  SSCHF,
  SSTAMM,
  SWTYP,
} from './baseitemsDB';
import { DBStatus, DelStatus } from 'src/app/types/api';
import { FileForPreview } from 'src/app/content/_components/_shared/preview-thumbnails/preview-thumbnail.type';
import { SZUMZ } from './mangelBaumDB';
import { OMAZS } from './mangelDB';
import { inject, Injectable, NgZone } from '@angular/core';

//#region Interfaces
export interface User {
  ID: number;
}

export interface PSYNST {
  ID: number;
  Status: number;
  FileName: string;
  RepStatusTime: string /* DateTime */;
  MasterID: number;
  UserName: string;
  SynchronIdent: number;
  SynchronFile: string;
  SynchronTime: string /* DateTime */;
  RepFunction: number;
  RepPruefTYP: number;
}

export interface OPRUEF {
  ID?: number;
  OPRUEFID?: number;
  OSTAMMID: number;
  P_Datum?: string;
  P_IntStatus?: string;
  P_DelStatus?: number;
  P_Bemerkung?: string;
  P_MUser?: string;
  P_MTol?: string;
  P_MDatum?: string;
  P_MinFK?;
  UserName;
  Status;
  BWPZN?: number;
  M_Mess_Start?;
  M_Device?;
  P_KeinePruefung?;
  P_KeinePrfGrund?;
  B_BUEBildPfade?: string;
  KPRTYPID?: number;
  P_ALV_Checked?;
  P_Kunde_U?;
  P_Pruefer_U?;
  P_Kunde?;
  P_Vorlage?;
  KAV00?;
  KAV01?;
  KAV02?;
  KAV03?;
  KAV04?;
  KAV05?;
  KAV06?;
  KAV07?;
  L_Mangel?;
  L_MangelFK1?;
  L_MangelFK2?;
  L_MangelFK3?;
  L_MangelFK4?;
  L_MangelCFK1?;
  L_MangelCFK2?;
  L_MangelCFK3?;
  L_MangelCFK4?;
  P_ZUser?;
  P_ZDatum?;
  M_Mess_Drehen?;
  P_Pruefer?;
  L_MangelFK5?;
  L_MangelFK6?;
  L_MangelFK7?;
  L_MangelFK8?;
  L_MangelFK9?;
  L_MangelCFK5?;
  L_MangelCFK6?;
  L_MangelCFK7?;
  L_MangelCFK8?;
  L_MangelCFK9?;
  P_ALV_CheckDate?;
  P_ALV_Name?;
  P_ALV_Bemerkung?;
  P_ALV_Status?;
  P_EBL_Checked?;
  P_EBL_CheckDate?;
  P_EBL_Name?;
  P_EBL_Bemerkung?;
  P_EBL_Status?;
}

export interface OHERST {
  ID?: number;
  OSPEZID?: number;
  Hersteller?;
  Einbaudatum?;
  Einbaufirma?;
  LageplanNr?;
  VerlegeplanNr?;
  DauerGewaehrleistung?;
  EinheitGewaehrleistung?;
  EndeGewaehrleistung?;
  UserName: string;
  Status;
  Nutzungsdauer?;
  Erneuerungsjahr?;
  Herstelldatum?;
}

export interface SXMGR {
  ID?: number;
  Typ: number;
  AnlagenobjektID: number;
  BenutzerGruppeID: number;
}

export interface SXMREP {
  ID?: number;
  OSTAMMID: number;
  REPID: number;
  UserName: string;
  Status;
}

export interface SXMKP {
  ID?: number;
  OSTAMMID: number;
  KPRUVID?: number;
  IVAL_HP?: number;
  IVAL_Beginn_HP?: string;
  IVAL_MS?: number;
  IVAL_Beginn_MS?: string;
  ZAEID_HP?: number;
  UserName: string;
  Status: string;
}
export interface KPRUV extends DelStatus {
  ID?: number;
  Bezeichnung?: string;
  Base_IVAL_HP?: number;
  Base_IVAL_MS?: number;
  UserName: string;
  Status: string;
}

export interface KBNGR {
  ID?: number;
  Bezeichnung: string;
  Rechte: string;
  UserName: string;
  Status: string;
  DelStatus: number;
}

export interface KGMKO {
  StammID: number;
  Koordinaten: string;
}

export interface OSPEZ {
  ID?: number;
  OSPEZID: number;
  OSTAMMID?: number;
  OKOMPID?: number;
  s_StartMeter?: number;
  s_EndMeter?: number;
  strValue01?;
  strValue02?;
  strValue03?;
  strValue04?;
  strValue05?;
  strValue06?;
  strValue07?;
  strValue08?;
  strValue09?;
  strValue10?;
  strValue11?;
  strValue12?;
  strValue13?;
  strValue14?;
  strValue15?;
  strValue16?;
  strValue17?;
  strValue18?;
  strValue19?;
  strValue20?;
  strValue21?;
  strValue22?;
  strValue23?;
  strValue24?;
  strValue25?;
  strValue26?;
  strValue27?;
  strValue28?;
  strValue29?;
  strValue30?;
  strValue31?;
  strValue32?;
  strValue33?;
  strValue34?;
  strValue35?;
  strValue36?;
  strValue37?;
  strValue38?;
  strValue39?;
  strValue40?;
  strValue41?;
  strValue42?;
  strValue43?;
  strValue44?;
  strValue45?;
  strValue46?;
  strValue47?;
  strValue48?;
  strValue49?;
  strValue50?;
  intValue01?;
  intValue02?;
  intValue03?;
  intValue04?;
  intValue05?;
  intValue06?;
  intValue07?;
  intValue08?;
  intValue09?;
  intValue10?;
  intValue11?;
  intValue12?;
  intValue13?;
  intValue14?;
  intValue15?;
  dblValue01?;
  dblValue02?;
  dblValue03?;
  dblValue04?;
  dblValue05?;
  dblValue06?;
  dblValue07?;
  dblValue08?;
  dblValue09?;
  dblValue10?;
  dblValue11?;
  dblValue12?;
  dblValue13?;
  dblValue14?;
  dblValue15?;
  chkValue01?;
  chkValue02?;
  chkValue03?;
  chkValue04?;
  chkValue05?;
  chkValue06?;
  chkValue07?;
  chkValue08?;
  chkValue09?;
  chkValue10?;
  chkValue11?;
  chkValue12?;
  chkValue13?;
  chkValue14?;
  chkValue15?;
  dateValue01?;
  dateValue02?;
  dateValue03?;
  dateValue04?;
  dateValue05?;
  dateValue06?;
  dateValue07?;
  dateValue08?;
  dateValue09?;
  dateValue10?;
  dateValue11?;
  dateValue12?;
  dateValue13?;
  dateValue14?;
  dateValue15?;
  Bemerkung?;
  BWert?;
  UserName;
  Status;
}

export interface OBAUW {
  ID?: number;
  OSTAMMID: number;
  b_StartMeter;
  b_EndMeter;
  b_Art;
  b_Bezeichnung;
  b_Zustand?;
  b_ParentID?;
  b_Bild?;
  b_GPS;
  UserName: string;
  Status: string;
  b_Lage?;
  RailDeep?;
  Bild64?;
}

export interface ONATUR extends DBStatus {
  ID?: number;
  OSTAMMID: number;
  b_Position: number;
  b_Typ: string;
  b_Bezeichnung: string;
  b_Bild: string;
  b_Beschreibung: string;
}

export interface OBEGE extends DBStatus {
  ID?: number;
  Titel?: string;
  BeginnDatum?: string;
  Intervall?: number;
  Tag?: number;
  LPOBEGPID?: number;
  LPDatum?: string;
  LPCompleted?: boolean;
  Bemerkung?: string;
  Gruppen?: string;
}

export interface OBEGP {
  ID?: number;
  OBEGEID?;
  BegehDatum?;
  Completed?;
  Bemerkung?;
  UserName: string;
  Status: string;
  BegehungsArt?;
}

export interface OBUESD extends DBStatus {
  ID?: number;
  OPRUEFID: number;
  Bezeichnung: string;
  QUADRANT1_2?: string;
  QUADRANT3_4?: string;
}

export interface SXBEP {
  ID?: number;
  OBEGP?: number;
  OSTAMMID?: number;
  Completed?: boolean;
  MangelID?: string;
  CompletedDate?: string;
  UserName: string;
  PBild?: string;
}
export interface SXBEG {
  ID?: number;
  OBEGEID: number;
  OSTAMMID: number;
}

export interface OPBILD {
  ID?: number;
  OSTAMMID: number;
  OPRUEFID: number;
  P_Bild: string;
}

export interface KSPEZV {
  ID?: number;
  OTYPID?: number;
  SFELDNA?: string;
  KFELDNA?: string;
  PFLICHT?: boolean;
  USEWERT?: boolean;
  TABWERT?: string;
  TABWERT_ID?: number;
  KSORT?: string;
  UserName: string;
  Status: string;
}

export interface OMESS extends DBStatus {
  ID?: number;
  OPRUEFID: number;
  Bezeichnung: string;
  Soll: number | 'Ja';
  SR100plus: number;
  SR100minus: number;
  SRlimplus: number;
  SRlimminus: number;
  SRGplus: number;
  SRGminus: number;
  Ist: number | 'Ja' | 'Nein' | 'n.g.';
  Ausfall: string;
  Instand?: string;
  Instand_Datum?: string /* Datum */;
  Instandsetzer?: string;
  Messender: string;
  INFO: string;
  ZTYP: number;
  IAusfall?: string;
  Bemerkung: string;
  Ex_Infralife?: boolean;
  mPosition?: number;
  SZAEHNID: number;
  isHeader: boolean;
  Bild?: string;
  x_pruef_date?;
  x_bezirk?;
  x_stellwerk?;
  x_messregbezirk?;
}
export interface SYSOOPT {
  ID?: number;
  OTYPID: number;
  KPRTYPID: boolean;
  Opt_I_Del_Old_Image: boolean;
  Opt_I_Fehlerklasse: boolean;
  Opt_I_PassBild: boolean;
  Opt_I_Zustaend_Abt: boolean;
  Opt_I_Track_Ber_Laenge: boolean;
  Opt_I_Track_Spez_SchwellenNote: boolean;
  Opt_I_Track_Spez_Schwellenjahr: boolean;
  Opt_I_Track_Spez_Schienenhoehe: boolean;
  Opt_I_Track_Spez_Schienenjahr: boolean;
  Opt_I_Track_Spez_Option_ZusatzI: boolean;
  Opt_I_Track_Spez_Option_ZusatzII: boolean;
  Opt_I_Track_Spez_Option_Unterbau: boolean;
  Opt_I_Track_Spez_Option_Einbaujahr: boolean;
  Opt_I_Track_Spez_Option_Daemmung: boolean;
  Opt_I_Track_Spez_Option_GisID: boolean;
  Opt_I_Track_Spez_Option_ZustandsNote: boolean;
  Opt_I_CheckList: boolean;
  Opt_F_Stellkraftmessung: boolean;
  Opt_F_Naturschutz: boolean;
  Opt_I_Gundinst: boolean;
  Opt_F_BUESicht: boolean;
  Opt_F_Drawing: boolean;
  Opt_F_Zaehler: boolean;
  Opt_F_ZaehlerMessreg: boolean;
  Opt_O_UseMessReg: boolean;
}

export interface KBEZNG {
  ID?: number;
  FeldName: string;
  KBezeichnung: string;
  KShow: boolean;
  KPflicht: boolean;
  UserName: string;
  Status: any;
}

export interface OMZLOG {
  ID?: number;
  OMAZSID: number;
  LogTyp: string;
  AuftragNr: number;
  UserName: string;
  Status: any;
}

export interface KSTPVG {
  ID?: number;
  OTYPID: number;
  Titel: string;
  PruefartID: number;
  SortID: number;
  Gesperrt?: number;
  UserName: string;
  Status: any;
  Bezeichnungen?: any;
  Pruefart?: any;
}

export interface KINTERF {
  ID: 1;
  optSAPFieldTermin: boolean;
  optSAPFieldAusfall: boolean;
  optSAPFieldEquipment: boolean;
  optZFeld1Required: boolean;
  optZFeld2Required: boolean;
  optZFeld3Required: boolean;
  optZFeld4Required: boolean;
  optZFeld5Required: boolean;
  optZFeld1Title: string;
  optZFeld2Title: string;
  optZFeld3Title: string;
  optZFeld4Title: string;
  optZFeld5Title: string;
}

export interface SYSINI {
  ID: 1;
  optMINNumFK: number;
  optMAXNumFK: number;
  optFk1_IstGleich_BG: boolean;
  optDownChangeFK: boolean;
  KAV17?: number;
  Opt_O_UseMessReg?: boolean;
  GISMAP?: string;
  optFKColors: string;
}
export interface SXMBG {
  ID?: number;
  BenutzerID: number;
  BenutzerGruppeID: number;
}

export interface SXKPO {
  ID: number;
  KPRUVID: number;
  OTYPID: number;
}

export interface ReplikatMedia {
  pfad: string;
  name: string;
  file: FileForPreview;
}
//#endregion

export function IsRep(): boolean {
  return (
    localStorage.getItem('repID') != null &&
    localStorage.getItem('repDB') != null &&
    localStorage.getItem('repDB') == (localStorage.getItem('intdb') || localStorage.getItem('DB'))
  );
}

export function GetRepID(): number {
  return IsRep() ? +localStorage.getItem('repID') : null;
}

export type TableByName<Name extends keyof typeof AppDB, Interface extends object = {}> =
  (typeof AppDB)[Name] extends Table<infer Table extends Interface> ? Table : never;

@Injectable({ providedIn: 'root' })
export class AppDB extends Dexie {
  private readonly zone = inject(NgZone);

  //#region Declaring tables
  meta!: Table<ReplikatMeta, string>;
  media!: Table<ReplikatMedia, string>;

  kinterf!: Table<KINTERF, number>;
  kpruv!: Table<KPRUV, number>;
  kbngr!: Table<KBNGR, number>;
  kgmko!: Table<KGMKO, number>;
  kspezv!: Table<KSPEZV, number>;
  kbezng!: Table<KBEZNG, number>;
  kstpvg!: Table<KSTPVG, number>;
  ktolr!: Table<KTOLR, number>;
  kzuwa!: Table<KZUWA, number>;
  kwaart!: Table<KWAART, number>;
  kwaarb!: Table<KWAARB, number>;
  kwaprs!: Table<KWAPRS, number>;
  kwaman!: Table<KWAMAN, number>;
  kwamas!: Table<KWAMAS, number>;
  kwapru!: Table<KWAPRU, number>;
  kwastm!: Table<KWASTM, number>;
  kwamgz!: Table<KWAMGZ, number>;
  kwamzn!: Table<KWAMZN, number>;

  nmess!: Table<NMESS, number>;

  ostamm!: Table<OSTAMM, number>;
  opruef!: Table<OPRUEF, number>;
  ospez!: Table<OSPEZ, number>;
  oherst!: Table<OHERST, number>;
  obauw!: Table<OBAUW, number>;
  onatur!: Table<ONATUR, number>;
  omazs!: Table<OMAZS, number>;
  omzlog!: Table<OMZLOG, number>;
  omess!: Table<OMESS, number>;
  opbild!: Table<OPBILD, number>;
  obege!: Table<OBEGE, number>;
  obegp!: Table<OBEGP, number>;
  obuesd!: Table<OBUESD, number>;

  sotyp!: Table<SOTYP, number>;
  sxmgr!: Table<SXMGR, number>;
  sxmkp!: Table<SXMKP, number>;
  sxbeg!: Table<SXBEG, number>;
  sxbep!: Table<SXBEP, number>;
  sysoopt!: Table<SYSOOPT, number>;
  //#region BaseItems
  kspezw!: Table<KSPEZW, number>;
  sbauw!: Table<SBAUW, number>;
  sbfek!: Table<SBFEK, number>;
  sschf!: Table<SSCHF, number>;
  swtyp!: Table<SWTYP, number>;
  sbagp!: Table<SBAGP, number>;
  sschw!: Table<BASE_ITEM, number>;
  sbeft!: Table<BASE_ITEM, number>;
  seind!: Table<BASE_ITEM, number>;
  szubf!: Table<BASE_ITEM, number>;
  svest!: Table<BASE_ITEM, number>;
  suntg!: Table<BASE_ITEM, number>;
  sradl!: Table<BASE_ITEM, number>;
  srich!: Table<BASE_ITEM, number>;
  santr!: Table<BASE_ITEM, number>;
  //#endregion
  //#region MangelBaum
  szumz!: Table<SZUMZ, number>;
  sgatt!: Table<SGATT, number>;
  sstamm!: Table<SSTAMM, number>;
  sprue!: Table<BASE_ITEM_OTYPID, number>;
  slage!: Table<BASE_ITEM_OTYPID, number>;
  smang!: Table<SMANG, number>;
  sinst!: Table<BASE_ITEM_OTYPID, number>;
  smeh!: Table<BASE_ITEM, number>;
  kequi!: Table<BASE_ITEM_OTYPID, number>;
  //#endregion
  sysini!: Table<SYSINI, number>;
  szaeeh!: Table<SZAEEH, number>;
  szaehn!: Table<SZAEHN, number>;
  szaehw!: Table<SZAEHW, number>;
  sxmbg!: Table<SXMBG, number>;
  sxkpo!: Table<SXKPO, number>;
  user!: Table<User, number>;
  psynst!: Table<PSYNST, number>;
  //#endregion

  KPflicht: boolean;
  nowFormat: string = 'YYYY-MM-DDTHH:mm:ss';

  constructor() {
    super(`Replikat`);
    this.version(1).stores({
      meta: '&tableName',
      media: '&name, pfad',

      kinterf: '++ID',
      kequi: '++ID, OTYPID',
      kpruv: '++ID',
      kbngr: '++ID, Bezeichnung, Rechte, DelStatus',
      kgmko: '++ID, StammID',
      kspezv: '++ID, OTYPID, SFELDNA, KFELDNA, PFLICHT, USEWERT, TABWERT, KSORT',
      kspezw: '++ID, TABWERT_ID, Bezeichnung',
      kbezng: '++ID, FeldName, KBezeichnung, KShow, KPflicht',
      kstpvg: '++ID, OTYPID, [OTYPID+Titel]',
      ktolr: '++ID',
      kzuwa: '++ID, OTYPID, RevArtID',
      kwaarb: '++ID, OTYPID',
      kwaart: '++ID, OTYPID',
      kwaman: '++ID, OTYPID',
      kwaprs: '++ID, OTYPID',
      kwamas: '++ID, RevMaskenNameID, Sortierung',
      kwapru: '++ID,[RevStammID+RevMaskenNameID]',
      kwastm: '++ID,[OSTAMMID+RevMaskenID],Zustaedigkeit,RevBeginn',
      kwamgz: '++ID,RevPruefungID',
      kwamzn: '++ID,RevMaskenNameID',

      nmess: '++ID, [Typ+Bezeichnung]',

      opruef: '++ID, OPRUEFID, OSTAMMID, P_Datum, [OSTAMMID+P_IntStatus+KPRTYPID+P_DelStatus+P_Datum+OPRUEFID]',
      ostamm: '++ID, OSTAMMID, OTYPID, DelStatus',
      ospez: '++ID, OSPEZID, OSTAMMID, OKOMPID, s_StartMeter, strValue01, strValue02',
      obauw: '++ID, OSTAMMID, b_StartMeter, b_EndMeter, b_ParentID',
      onatur: '++ID, OSTAMMID, b_Position, b_Typ',
      oherst: '++ID, OSPEZID,Einbaudatum',
      opbild: '++ID, [OSTAMMID+OPRUEFID], P_Bild',
      obege: '++ID, Titel',
      obegp: '++ID, OBEGEID',
      omazs: '++ID, OMAZSID, OSTAMMID, [OPRUEFID+OSTAMMID+OMARTID+lfNr], [OPRUEFID+OMAZSID], StartMeter',
      omzlog: '++ID, OMAZSID',
      omess: '++ID, OPRUEFID, Bezeichnung, ZTYP, SZAEHNID',
      obuesd: '++ID, [OPRUEFID+Bezeichnung]',
      sbauw: '++ID, Bezeichnung, Pruefung, OTYPID',
      sotyp: '++ID, Name, Bezeichnung, Typ, SysIcon, ParentOTypID, ParentID',
      sxmrep: '++ID, OSTAMMID, REPID',
      sxmgr: '++ID, Typ, AnlagenobjektID, BenutzerGruppeID',
      sxmkp: '++ID, [KPRUVID+OSTAMMID]',
      sxbeg: '++ID, OBEGEID, OSTAMMID',
      sxbep: '++ID, OSTAMMID, [OBEGP+OSTAMMID]',
      sysoopt: '++ID, OTYPID',
      sprue: '++ID, OTYPID, Bezeichnung',
      sbfek: '++ID, Bezeichnung, Schienenform_ID, Schwellenart_ID, Schienenbefestigung_ID, Eindeckung_ID, OTYPID',
      sschf: '++ID, Bezeichnung, Typ',
      sschw: '++ID, Bezeichnung',
      sbeft: '++ID, Bezeichnung',
      seind: '++ID, Bezeichnung',
      sgatt: '++ID, OTYPID, IntID',
      sstamm: '++ID, [OTYPID+GattungID], Bezeichnung',
      sinst: '++ID, OTYPID, GattungID, Bezeichnung',
      szubf: '++ID, Bezeichnung',
      swtyp: '++ID, Bezeichnung',
      svest: '++ID, Bezeichnung',
      suntg: '++ID, Bezeichnung',
      sradl: '++ID, Bezeichnung',
      srich: '++ID, Bezeichnung',
      sbagp: '++ID, Name',
      santr: '++ID, Bezeichnung',
      smeh: '++ID, Bezeichnung',
      slage: '++ID, OTYPID, Bezeichnung',
      smang: '++ID, OTYPID, SMATYID, Bezeichnung',
      sysini: '++ID',
      szumz: `++ID,
        [OTYPID+GattungID+StammID+PruefartID+MangelID+InstandsetzungID],
        [OTYPID+PruefartID+LageID+MangelID+InstandsetzungID],
        zuAbt, Equipment, LVPos, ZFeld1, ZFeld2, ZFeld3, ZFeld4, ZFeld5`,
      szaeeh: '++ID, OTYPID, DelStatus',
      szaehn: '++ID, OTYPID, DelStatus, FATVOLID, SourceType',
      szaehw: '++ID, SZAEHNID, DelStatus, I_SORT',
      sxmbg: '++ID, BenutzerID, DelStatus',
      sxkpo: '++ID',

      user: 'ID',
      psynst: 'SynchronIdent',
    });
    //   this.on('populate', () => this.populate());
  }

  //#region Aliases
  aliasMangel = {
    startmeter: 'von',
    endmeter: 'bis',
    gattung: 'gattung',
    lage: 'lage',
    mangel: 'mangel',
    instandsetzung: 'instandsetzungshinweis',
    fehlerklasse: 'fehlerklasse',
    umfang: 'umfang',
    mengeneinheit: 'mengeneinheit',
    abteilung: 'abteilung',
    betriebsgefahr: 'betriebsgefahr',
    bemerkung: 'bemerkung',
    stamm: 'stamm',
    pruefart: 'pruefart',
    szumzid: 'szumzid',
    faktor: 'faktor',
    erledigt: 'erledigtStatus',
    e_datum: 'Erledigt_am',
    e_firma: 'Erledigt_durch',
    prozentfaktor: 'prozentfaktor',
    fk_hand: 'fk_aenderung',
    gattungid: 'gattung_id',
    kavaae: 'abnutzungsaequivalent',
    kavaw: 'anteilige_wichtung',
    ep: 'preis',
    auftrag: 'auftrag',
    termin: 'termin',
    AuftragNr: 'auftrag_nr',
    auftragsart: 'auftragsart',
    auftragnehmer: 'auftragnehmer',
    sapexport: 'sap_export',
    meldstat: 'MELDSTAT',
    meldnr: 'meld_nr',
    aufstat: 'aufstat',
    zuAbt: 'abteilung',
    status: 'status',
    ostammid: 'ostammid',
    fk: 'fehlerklasse',
  };

  aliasMessungen = {
    p_datum: 'pruefdatum',
    soll: 'sollmass',
    sr100plus: 'sr_100_plus',
    sr100minus: 'sr_100_minus',
    srlimplus: 'sr_lim_plus',
    srlimminus: 'sr_lim_minus',
    ausfall: 'tolverl',
    instand: 'ist_neu',
    iausfall: 'tolverl_neu',
    instand_datum: 'instandsetzung_vom',
    messender: 'pruefer',
  };

  selectMangelAnl = [
    'OMAZSID',
    'OSTAMMID',
    'ostammid',
    'pruefDatum',
    'StartMeter',
    'EndMeter',
    'Pruefart',
    'Lage',
    'Mangel',
    'Instandsetzung',
    'Umfang',
    'nIO',
    'Mengeneinheit',
    'FK',
    'Betriebsgefahr',
    'Bild',
    'Erledigt',
    'E_Datum',
    'E_Firma',
    'InstPic1',
    'ProzentFaktor',
    'FK_Hand',
    'Gattung',
    'GattungID',
    'Stamm',
    'KAVAAE',
    'KAVAW',
    'EP',
    'Auftrag',
    'Termin',
    'AuftragNr',
    'Auftragsart',
    'Auftragnehmer',
    'SAPExport',
    'MELDSTAT',
    'MELDNR',
    'AUFSTAT',
    'Faktor',
    'Bemerkung',
    'UserName',
    'Status',
    'lfNr',
  ];
  //#endregion

  //Wandelt in Frontend-Tabellenformat um. Beachten: bei der replaceList muss der Key in lowercase sein!
  parseToFrontEnd(rows: any[], allowNull?: boolean, replaceList?: { [key: string]: string }, deleteList?: string[]) {
    const dtFE = {
      columns: [],
      rows: [],
    };

    if (rows.length == 0) return allowNull ? null : dtFE;
    const toReplace = replaceList && Object.keys(replaceList).length > 0;

    Object.entries(rows[0]).forEach(([id, value]) => {
      if (toReplace) {
        const replacing = id.toLowerCase();
        if (replacing in replaceList) id = replaceList[replacing];
      }

      const column = { id, bezeichnung: id.toUpperCase(), type: !Number.isNaN(value) ? 'number' : 'string' };
      dtFE.columns.push(column);
    });

    dtFE.rows = toReplace || deleteList?.length ? this.renObj(rows, replaceList, deleteList) : rows;

    return dtFE;
  }

  renObj(rows: any[], replaceList?: { [key: string]: string }, deleteList?: string[]) {
    const toReplace = replaceList && Object.keys(replaceList).length > 0;
    if (!toReplace && !deleteList?.length) return rows;

    return rows.map(row =>
      Object.fromEntries(
        Object.entries(row).flatMap(([key, value]) => {
          if (deleteList?.includes(key)) return [];
          if (toReplace) {
            const replacing = key.toLowerCase();
            if (replacing in replaceList) key = replaceList[replacing];
          }
          if (deleteList?.includes(key)) return [];

          return [[key, value]]; // [] u. [[k,v]] => flatMap => undefined (skiped) u. [k,v]
        })
      )
    );
  }

  // Entspricht einem "Select a,b,...n" in einem SQL-Query mit entsprechender Sortierung
  public Select(obj, allowed): any {
    return obj.map(x =>
      Object.keys(x)
        .filter(key => allowed.includes(key))
        .sort((a, b) => {
          if (!allowed.includes(a)) return 1;
          if (!allowed.includes(b)) return -1;
          return allowed.indexOf(a) - allowed.indexOf(b);
        })
        .reduce((obj, key) => {
          obj[key] = x[key];
          return obj;
        }, {})
    );
  }

  public getstammfield(dt, field) {
    let ret = null;
    if (dt)
      for (const dr of dt.rows) {
        if (dr['FeldName'] == field) {
          this.KPflicht = dr['KPflicht'];
          ret = dr['KBezeichnung'];
          break;
        }
      }
    return ret;
  }

  public async getMessungAuswertung(req: any): Promise<any> {
    switch (req.status) {
      case 'inspektion':
        const pruef: OPRUEF[] = (
          await this.opruef.where('OSTAMMID').equals(req.ostammid).limit(5).sortBy('P_Datum')
        ).reverse();
        const messArr = await this.omess.toArray();
        const pruefArr = await this.opruef.toArray();
        if (pruef.length > 0) {
          const pruefid: number = pruef[0].OPRUEFID;
          const mess = messArr.filter(x => x.ZTYP == 0 && x.OPRUEFID == pruefid);
          const messFE = this.parseToFrontEnd(mess, false, {
            SR100plus: 'SR 100 +',
            SR100minus: 'SR 100 -',
            SRlimplus: 'SR lim +',
            SRlimminus: 'SR lim -',
            SRGplus: 'SRG +',
            SRGminus: 'SRG -',
          });
          if (messFE == null) return null;
          let messHistoric = messArr.filter(x => x.SZAEHNID == 0 && x.ZTYP == 0 && x.OPRUEFID == pruefid);
          messHistoric = await Promise.all(
            messHistoric.map(async x => {
              x.x_pruef_date = pruefArr.find(y => y.OPRUEFID == x.OPRUEFID).P_Datum;
              return x;
            })
          );

          const existingDates = [];
          messFE.rows.forEach(mess => {
            messHistoric.forEach(his => {
              if (his['Bezeichnung'] == mess['Bezeichnung'] && his['OPRUEFID'] != pruefid) {
                const date = his['x_pruef_date'];
                const tolVerl = 'Tol-Verl:' + date;
                mess[date] = his['ist'];
                mess[tolVerl] = his['tolverl'];
                if (!existingDates.includes(date)) {
                  const dc = messFE.columns;
                  dc.splice(12, 0, { id: date.toUpperCase(), bezeichnung: date });
                  dc.splice(13, 0, { id: tolVerl.toUpperCase(), bezeichnung: tolVerl });
                  existingDates.push(date);
                }
              }
            });
          });

          return messFE;
        }
        break;
      case 'getmess':
        const pruefids: string = req.pruefid.join(',');
        const stamm = this.ostamm.get({ OSTAMMID: req.ostammid });
        const a = this.getstammfield(stamm, 'Bezirk');
        const b = this.getstammfield(stamm, 'Stellwerk');
        const c = this.getstammfield(stamm, 'MessRegBezirk');
        let mess = (await this.omess.toArray()).filter(
          x => pruefids.includes(x.OPRUEFID.toString()) && x.SZAEHNID == 0
        );
        mess = await Promise.all(
          mess.map(x => {
            [x.x_bezirk, x.x_stellwerk, x.x_messregbezirk] = [a, b, c];
            return x;
          })
        );
        // const messFE = this.parseToFrontEnd(mess, false, {
        //   SR100plus: tol.TEXT_100_p,
        //   SR100minus: tol.TEXT_100_m,
        //   SRlimplus: tol.TEXT_L_p,
        //   SRlimminus: tol.TEXT_L_m,
        //   SRGplus: tol.TEXT_G_p,
        //   SRGminus: tol.TEXT_G_m,
        // });

        break;
      case 'getcount':
        break;
      default:
        break;
    }
  }

  public async getAnlagenHistorie(id: number) {
    return await this.zone.runOutsideAngular(async () => {
      const historie = [];

      const opruef = (await this.opruef.where('OSTAMMID').equals(id).sortBy('OSPEZID')).map(x => x.OPRUEFID);
      const ospez = (await this.ospez.where('OSTAMMID').equals(id).sortBy('OSPEZID')).map(x => x.OSPEZID);
      const tbl = await Promise.all([
        this.oherst.where('OSPEZID').anyOf(ospez).toArray(),
        this.opruef.toArray(),
        this.omess.toArray(),
        this.omazs.toArray(),
      ]);
      let messVal = tbl[2]
        .filter(x => opruef.includes(x.OPRUEFID))
        .map(x => {
          x.x_pruef_date = tbl[1].find(y => y.OPRUEFID == x.OPRUEFID).P_Datum;
          return x;
        });
      messVal = [...new Map(messVal.map(x => [x.x_pruef_date, x])).values()];

      const listBegehung = [];
      const sxbep = await this.sxbep.where({ OSTAMMID: id }).toArray();
      await Promise.all(
        sxbep.map(async bep => {
          const begp = (await this.obegp.toArray()).filter(x => x.ID == bep.OBEGP);
          await Promise.all(
            begp.map(async begp => {
              const bege = await this.obege.get({ ID: begp.OBEGEID });
              listBegehung.push({ Key: bege.Titel, Value: [{ id: begp.ID, datum: begp.BegehDatum }] });
            })
          );
        })
      );

      const listWartungen = [];
      const kwapru = (await this.kwapru.toArray())
        .filter(x => x.RevStammID == id)
        .sort((a, b) => b.RevDatum.localeCompare(a.RevDatum));
      await Promise.all(
        kwapru.map(async pru => {
          const kwaman = await this.kwaman.get({ ID: pru.RevMaskenNameID });
          const maske = kwaman.Name ?? '---';
          listWartungen.push({ Key: maske, Value: [{ id: pru.ID, datum: pru.RevDatum }] });
        })
      );

      (historie.push({
        Key: 'herstellerdaten',
        Value: this.renObj(tbl[0], { einbaudatum: 'date' }),
      }),
        historie.push({
          Key: 'inspektionen',
          Value: this.renObj(
            tbl[1]
              .filter(x => x.OSTAMMID == id && !x.P_DelStatus && x.P_IntStatus != 'messung')
              .sort((a, b) => b.P_Datum.localeCompare(a.P_Datum)),
            { p_datum: 'date', opruefid: 'id' }
          ),
        }),
        historie.push({
          Key: 'messungen',
          Value: this.renObj(messVal, { x_pruef_date: 'date' }),
        }),
        // historie["sperrungen"] = (await this.osperr.where("ostammid").equals(id).sortBy("bdatum")).reverse,
        historie.push({
          Key: 'stoerungen',
          Value: this.renObj(
            tbl[3].filter(x => x.OSTAMMID == id && x.OMARTID == 3).sort((a, b) => b.M_Datum.localeCompare(a.M_Datum)),
            { m_datum: 'date', omazsid: 'id' }
          ),
        }),
        // historie["langsamfahrstellen"] = (await this.oslfst.where("ostammid").equals(id).sortBy("bdatum")).reverse,
        historie.push({
          Key: 'instandsetzungen',
          Value: this.renObj(
            tbl[3]
              .filter(x => x.Erledigt == true && x.Mangel != null)
              .sort((a, b) => b.E_Datum.localeCompare(a.E_Datum)),
            { e_datum: 'date' }
          ),
        }));
      if (listBegehung.length > 0)
        historie.push({
          Key: 'begehung',
          Value: listBegehung,
        });
      if (listWartungen.length > 0)
        historie.push({
          Key: 'wartungen',
          Value: listWartungen,
        });

      for (let index = historie.length - 1; index >= 0; index--) {
        const element = historie[index];
        if (element.Value.length == 0) historie.splice(index, 1);
      }
      return historie;
    });
  }

  public async getHistoryItem(ostammid: number, search: HistorieNode): Promise<DGTable> {
    return await this.zone.runOutsideAngular(async () => {
      const { idOrDate: searchVal } = search;
      switch (search.mode) {
        case 'wartungen': {
          /* SELECT art.Bezeichnung as Wartungsart, arb.Bezeichnung as 'Maßnahmen', k.RevZustand_iO as 'i.O.',
          k.Messwert, k.RevBild, if(k.RevPriorität > -1, k.RevPriorität, null) as FK, if(k.RevUmfang != -99, k.RevUmfang, null) as Umfang,
          k.RevME as Mengeneinheit, k.Arbeiter, k.UserName, k.Status

          FROM kwamgz k INNER JOIN kwaart art ON art.ID = k.RevArtID
          LEFT JOIN kwaarb arb ON arb.ID = k.RevArbID
          WHERE k.RevPruefungID = ? */

          const protokollItems = await this.kwamgz.where({ RevPruefungID: search.idOrDate }).toArray();
          const rows = await Promise.all(
            protokollItems.map(async item => {
              const {
                RevArtID: artID,
                RevArbID: arbID,
                RevGeprueft: _,
                RevMaskenNameID: __,
                RevPruefungID: ___ /* ignore */,
                RevZustand_iO: iO,
                RevPriorität: fk,
                RevUmfang: umfang,
                RevME: meh,
                ...protokollInfo /* alle andere einfach übernehmen */
              } = item;
              const art = await this.kwaart.get({ ID: item.RevArtID });
              if (!art) return null;
              const arb = await this.kwaarb.get({ ID: item.RevArbID });
              return {
                Wartungsart: art.Bezeichnung,
                Maßnahmen: arb?.Bezeichnung,
                ...protokollInfo,
                'i.O.': iO,
                FK: fk > -1 ? fk : null,
                Umfang: umfang != -99 ? umfang : null,
                Mengeneinheit: meh,
              };
            })
          );
          return {
            rows,
            columns: [
              'Wartungsart',
              'Maßnahmen',
              'i.O.',
              'Messwert',
              'RevBild',
              'FK',
              'Umfang',
              'Mengeneinheit',
              'Arbeiter',
              'UserName',
              'Status',
            ].map(id => ({ id })),
          } as DGTable;
        }
        case 'begehung': {
          const dt = await this.sxbep.where({ OBEGP: searchVal, OSTAMMID: ostammid }).toArray();
          const strFilter = ' WHERE OMAZSID =-1;';
          if (dt.length > 0) {
            const dr = dt[0];
            const f: string[] = dr['MangelID'].toString().split(';');

            // strSQL = "select omazs.opruefid, omazs.omazsid, (opruef.p_datum) as pruefdatum,"
            //    + (type == 4 ? "(omazs.StartMeter) as von, (omazs.EndMeter) as bis, " : "")
            //    + @"(omazs.pruefart) as pruefart, (omazs.lage) as lage, (omazs.mangel) as mangel, (omazs.instandsetzung) as instandsetzungshinweis,
            // (omazs.nio) as nicht_in_ordnung, (omazs.umfang) as umfang, (omazs.mengeneinheit) as mengeneinheit, (omazs.betriebsgefahr) as betriebsgefahr,
            // (omazs.bild) as bilder, (omazs.fk) as fehlerklasse, (omazs.auftrag) as auftrag, (omazs.termin) as termin,
            // (omazs.auftragnehmer) as auftragnehmer, (omazs.auftragsart) as auftragsart, (omazs.auftragnr) as auftragnr, (omazs.erledigt) as erledigt,
            // (omazs.e_datum) as erledigt_am, (omazs.e_firma) as erledigt_durch, (omazs.meldnr) as sapmelungnr, (omazs.meldstat) as sapmeldungstatus,
            // (omazs.aufstat) as sapauftragstatus, (omazs.sapeckende) as sapgewende, (omazs.sapeckendeneu) as sapgewendeneu,
            // (omazs.sapausfall) as ausfall_droht, (omazs.rueckmeldetext) as rueckmeldetext, (omazs.bemerkung) as bemerkung, (omazs.kosten) as kosten,
            // (omazs.stunden) as arbeitsstunden, (opbild.p_bild) as pruefbild, (omazs.verantwortlich) as verantwortlich, (omazs.username) as pruefer, (omazs.status) as status
            // from (omazs inner Join opruef on omazs.opruefid = opruef.opruefid) left join opbild on opbild.opruefid = opruef.opruefid ";
            // strSQL += strFilter;
            // strSQL += " and omazs.omartid<>3 order by opruef.p_datum desc, omazs.lfnr";

            if (f[0] != '') {
              let res = [];
              await Promise.all(
                f.map(async mgl => {
                  const man = await this.omazs.where('OMAZSID').equals(parseInt(mgl)).toArray();
                  await Promise.all(
                    man.map(async x => {
                      const opruef = await this.opruef.get({ OPRUEFID: x.OPRUEFID });
                      res.push({
                        ...x,
                        OPRUEFID: opruef.OPRUEFID,
                        pruefDatum: opruef.P_Datum,
                      });
                    })
                  );
                })
              );
              res = this.Select(res, this.selectMangelAnl);
              return this.parseToFrontEnd(res, true, this.aliasMangel);
            }
          }
          break;
        }
        case 'herstellerdaten': {
          //     result = DBCon.getTableFE(
          //        @"select oherst.id, ospez.ostammid, (oherst.hersteller) as hersteller, (oherst.herstelldatum) as herstelldatum,
          // (oherst.einbaufirma) as einbaufirma, (oherst.einbaudatum) as einbaudatum, (oherst.lageplannr) as lageplan_nr, (oherst.verlegeplannr) as verlegeplan_nr,
          // (oherst.dauergewaehrleistung) as dauer_gewaehrleistung, (oherst.einheitgewaehrleistung) as einheit_gewaehrleistung, (oherst.endegewaehrleistung) as ablauf_gewaehrleistung,
          // (oherst.nutzungsdauer) as geplante_nutzungsdauer, (oherst.username) as user, (oherst.status) as status
          // from ospez inner Join oherst on ospez.ospezid = oherst.ospezid where ospez.ostammid = ?",
          //         db, ostammid);
          const ospez = (await this.ospez.where('OSTAMMID').equals(ostammid).toArray()).map(x => x.OSPEZID);
          return this.parseToFrontEnd(await this.oherst.where('OSPEZID').anyOf(ospez).toArray(), true);
          break;
        }
        case 'inspektionen': {
          // result = DBCon.getTableFE(
          //    "select omazs.opruefid, omazs.omazsid, (opruef.p_datum) as pruefdatum,"
          //    + (type == "line" ? "(omazs.StartMeter) as von, (omazs.EndMeter) as bis, " : "")
          //    + @"(omazs.pruefart) as pruefart, (omazs.lage) as lage, (omazs.mangel) as mangel, (omazs.instandsetzung) as instandsetzungshinweis,
          // (omazs.nio) as nicht_in_ordnung, (omazs.umfang) as umfang, (omazs.mengeneinheit) as mengeneinheit, (omazs.betriebsgefahr) as betriebsgefahr,
          // (omazs.bild) as bilder, (omazs.InstPic1) as rueckbilder, (omazs.fk) as fehlerklasse, (omazs.auftrag) as auftrag, (omazs.termin) as termin,
          // (omazs.auftragnehmer) as auftragnehmer, (omazs.auftragsart) as auftragsart, (omazs.auftragnr) as auftragnr, (omazs.erledigt) as erledigt,
          // (omazs.e_datum) as erledigt_am, (omazs.e_firma) as erledigt_durch, (omazs.meldnr) as sapmelungnr, (omazs.meldstat) as sapmeldungstatus,
          // (omazs.aufstat) as sapauftragstatus, (omazs.sapeckende) as sapgewende, (omazs.sapeckendeneu) as sapgewendeneu,
          // (omazs.sapausfall) as ausfall_droht, (omazs.rueckmeldetext) as rueckmeldetext, (omazs.bemerkung) as bemerkung, (omazs.kosten) as kosten,
          // (omazs.stunden) as arbeitsstunden, (opbild.p_bild) as pruefbild, (omazs.verantwortlich) as verantwortlich, (omazs.username) as pruefer, (omazs.status) as status
          // from (omazs inner Join opruef on omazs.opruefid = opruef.opruefid) left join opbild on opbild.opruefid = opruef.opruefid where omazs.opruefid = ? and omazs.omartid<>3
          // order by opruef.p_datum desc , omazs.lfnr",
          //     db, searchVal);
          return this.parseToFrontEnd(
            await this.omazs.where('OPRUEFID').equals(searchVal).toArray(),
            true,
            this.aliasMangel
          );
          break;
        }
        case 'messungen': {
          //     return DBCon.getTableFE(
          //        @"select omess.id, omess.opruefid, (opruef.p_datum) as pruefdatum, (omess.bezeichnung) as bezeichnung,
          // (omess.soll) as sollmass, (omess.sr100plus) as sr_100_plus, (omess.sr100minus) as sr_100_minus, (omess.srlimplus) as sr_lim_plus,
          // (omess.srlimminus) as sr_lim_minus, (omess.ist) as ist, (omess.ausfall) as tolverl, (omess.instand) as ist_neu, (omess.iausfall) as tolverl_neu,
          // (omess.instand_datum) as instandsetzung_vom, (omess.instandsetzer) as instandsetzer, (omess.messender) as pruefer, (omess.username) as user,
          // (omess.status) as status
          // from opruef inner Join omess on opruef.opruefid = omess.opruefid where opruef.p_datum = ? and p_intstatus<>'messung' and opruef.ostammid = ?
          // order by omess.id",
          //         db, DBCon.SQLDatum(searchVal), ostammid);
          const pruefids = (await this.opruef.toArray()).filter(x => x.P_Datum == searchVal).map(x => x.OPRUEFID);
          return this.parseToFrontEnd(
            (await this.omess.toArray()).filter(x => pruefids.includes(x.OPRUEFID) && x.SZAEHNID == 0),
            true,
            this.aliasMessungen
          );
          break;
        }
        case 'instandsetzungen': {
          //     result = DBCon.getTableFE(
          //        @"select omazs.omazsid, opruef.opruefid, (opruef.p_datum) as pruefdatum, (omazs.lfnr) as pos,
          // (omazs.Bild) as bilder, (omazs.InstPic1) as rueckbilder,
          // (omazs.pruefart) as pruefart, (omazs.lage) as lage, (omazs.mangel) as mangel, (omazs.instandsetzung) as instandsetzungshinweis,
          // (omazs.nio) as nicht_in_ordnung, (omazs.umfang) as umfang, (omazs.mengeneinheit) as mengeneinheit, (omazs.betriebsgefahr) as betriebsgefahr,
          // (omazs.fk) as fehlerklasse, (omazs.auftrag) as auftrag, (omazs.termin) as termin, (omazs.auftragnehmer) as auftragnehmer,
          // (omazs.auftragsart) as auftragsart, (omazs.auftragnr) as auftragnr, (omazs.erledigt) as erledigt, (omazs.e_datum) as erledigt_am,
          // (omazs.e_firma) as erledigt_durch, (omazs.rueckmeldetext) as rueckmeldetext, (omazs.bemerkung) as bemerkung, (omazs.kosten) as kosten,
          // (omazs.stunden) as arbeitsstunden, (omazs.verantwortlich) as verantwortlich, (omazs.username) as pruefer, (omazs.status) as status
          // from (ostamm inner Join opruef on ostamm.ostammid = opruef.ostammid)
          // inner Join omazs on opruef.opruefid = omazs.opruefid
          // where (((ostamm.ostammid)= ? ) and omazs.Mangel IS NOT NUll AND omazs.Mangel != '' and ((omazs.e_datum)= ?) and ((omazs.erledigt)=1))",
          //         db, ostammid, DBCon.SQLDatum(searchVal));
          //     break;
          return this.parseToFrontEnd(await this.omazs.where('OSTAMMID').equals(ostammid).toArray());
        }
        case 'sonderinspektion':
        case 'sperrungen':
        case 'stoerungen':
        case 'langsamfahrstellen':
        case 'archiv':
          break;
      }
    });
  }

  public async filterGisMAP(features: any) {
    const filteredFeatures = [];
    const stm = await this.ostamm.toArray();
    const stmids = stm.map(a => a.OSTAMMID);

    features.forEach(feat => {
      if (stmids.includes(feat.getProperties().OSTAMMID)) filteredFeatures.push(feat);
    });
    return filteredFeatures;
  }
}
